(() => {
  if (!window.Lenis || window.leydiLenis || window.Shopify?.designMode) return;

  const headerOffset = () => -(document.querySelector('.section-header')?.offsetHeight || 0);
  const lenis = new Lenis({
    autoRaf: true,
    lerp: 0.1,
    smoothWheel: true,
    syncTouch: false,
    respectReducedMotion: true,
    stopInertiaOnNavigate: true,
    anchors: { offset: headerOffset() },
    allowNestedScroll: true,
    prevent: node => node.matches?.('.menu-drawer, .drawer, .search-modal, .header__submenu, .predictive-search, .disclosure__list-wrapper, [role="dialog"], [data-lenis-prevent]') || false
  });
  window.leydiLenis = lenis;

  const updateLock = () => {
    const locked = ['hidden', 'clip'].includes(getComputedStyle(document.body).overflowY);
    if (locked && !lenis.isStopped) lenis.stop();
    else if (!locked && lenis.isStopped) lenis.start();
  };
  const bodyObserver = new MutationObserver(updateLock);
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });

  let resizeFrame;
  const refresh = () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      lenis.options.anchors.offset = headerOffset();
      lenis.resize();
      updateLock();
    });
  };
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  updateLock();
})();
